import React, { useEffect, useState } from "react";
import * as url from "../../../helpers/url_helper";
import Request from "../../../helpers/request";
import { ToastContainer } from "react-bootstrap";
import { Card, CardBody, Col, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import Select from "react-select";
import AirHomeLoader from "../../../components/Common/AirHomeLoader";

function TopUsersGlobal() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [limit, setLimit] = useState<any>({ value: 5, label: "5" });

  const limitOptions = [
    { value: 5, label: "5" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  function handleLimit(value: any) {
    setLimit(value);
  }

  const fetchData = async () => {
    setLoading(true);

    try {
      const reqObj = {
        mode: "TOP_USERS_GLOBAL",
        limit: limit.value,
      };

      const response = await Request.post(
        `${url.BASE_URL}${url.DATE_WISE_STREAK_URL}`,
        reqObj,
      );

      setData(response.data?.data || []);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [limit]);

  const UserColumns = [
    {
      name: "Name",
      selector: (row: any) =>
        row?.firstname && row?.lastname
          ? `${row.firstname} ${row.lastname}`
          : "-",
      cell: (row: any) =>
        row?._id && row?.firstname && row?.lastname ? (
          <span className="">
            <a
              href={`/users/profile/${row._id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`${row.firstname} ${row.lastname}`}
            </a>
          </span>
        ) : (
          <span className="">{`${row.firstname} ${row.lastname}`}</span>
        ),
      sortable: true,
      grow: 2,
    },

    {
      name: "Phone Number",
      selector: (row: any) => row.mobile || "-",
      cell: (row: any) => <div>{row?.mobile || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "Streak Count",
      selector: (row: any) => row.noOfStreak || "-",
      cell: (row: any) => <div>{row?.noOfStreak || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "City Name",
      selector: (row: any) => row.cityName || "-",
      cell: (row: any) => <div>{row?.cityName || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },
  ];

  const Styles = {
    control: (provided: any, state: any) => ({
      ...provided,
      minHeight: 28,
      height: 30,
      fontSize: "10px",
      boxShadow: "none",
      width: "100px",
    }),

    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: 28,
    }),

    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "white",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      fontWeight: "normal",
      zIndex: 9999,
    }),

    placeholder: (provided: any) => ({
      ...provided,
      color: "#6c757d",
      fontWeight: "normal",
      fontSize: "13px",
    }),

    singleValue: (provided: any) => ({
      ...provided,
      color: "#333",
      fontWeight: "normal",
      fontSize: "14px",
    }),
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Row>
        <Col>
          <Card
            style={{
              marginTop: 30,
              marginLeft: 30,
              marginRight: 30,
              marginBottom: 0,
            }}
          >
            <CardBody>
              <Row>
                <Col>
                  <DataTable
                    columns={UserColumns}
                    data={data}
                    customStyles={customStyles}
                    subHeader
                    subHeaderComponent={
                      <div className="container-fluid p-0 pb-2">
                        <div className="d-flex justify-content-end align-items-end gap-3">
                          <div className="d-flex justify-content-start align-items-start me-auto">
                            <h5 className="fw-bold ">Top Users Global</h5>
                          </div>

                          <div className="d-flex justify-content-end align-items-end  gap-2">
                            <Select
                              options={limitOptions}
                              onChange={handleLimit}
                              styles={Styles}
                              value={limit}
                              placeholder="Select Limit"
                            />
                          </div>
                        </div>
                      </div>
                    }
                  />
                </Col>
              </Row>
              {loading && <AirHomeLoader />}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default TopUsersGlobal;

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};
